import { useState } from "react";

export const SEARCH_OPERATOR = {
  IS: "est",
  IS_NOT: "n'est pas",
  CONTAINS: "contient",
  DOES_NOT_CONTAIN: "ne contient pas",
  STARTS_WITH: "commence par",
  WITHIN_LAST_DAYS: "derniers",
};

const defaultResolve = (item, key) => item[key] || "";

const useSearchFilters = (fields, { initialFilters } = {}) => {
  const [filters, setFilters] = useState(initialFilters || []);

  const fieldsByKey = {};
  for (const field of fields) {
    fieldsByKey[field.key] = field;
  }

  const applyFilters = (items) => {
    let result = items;

    for (const filter of filters) {
      if (filter.values.length === 0) continue;
      const resolve = fieldsByKey[filter.field]?.resolve || defaultResolve;
      const valuesSet = new Set(filter.values);
      const needsLower = filter.operator === SEARCH_OPERATOR.CONTAINS || filter.operator === SEARCH_OPERATOR.DOES_NOT_CONTAIN || filter.operator === SEARCH_OPERATOR.STARTS_WITH;
      const valuesLower = needsLower ? filter.values.map((v) => v.toLowerCase()) : null;

      result = result.filter((item) => {
        const raw = resolve(item, filter.field);
        const resolved = Array.isArray(raw) ? raw : [raw || ""];

        switch (filter.operator) {
          case SEARCH_OPERATOR.IS:
            return resolved.some((v) => valuesSet.has(v));
          case SEARCH_OPERATOR.IS_NOT:
            return !resolved.some((v) => valuesSet.has(v));
          case SEARCH_OPERATOR.CONTAINS:
            return resolved.some((v) => valuesLower.some((fl) => v.toLowerCase().includes(fl)));
          case SEARCH_OPERATOR.DOES_NOT_CONTAIN:
            return !resolved.some((v) => valuesLower.some((fl) => v.toLowerCase().includes(fl)));
          case SEARCH_OPERATOR.STARTS_WITH:
            return resolved.some((v) => valuesLower.some((fl) => v.toLowerCase().startsWith(fl)));
          default:
            return true;
        }
      });
    }

    return result;
  };

  return { filters, setFilters, applyFilters };
};

export default useSearchFilters;
